//@deprecated
define('model/workflow.bucket.model',['require','exports','module','underscore','fukit'],function(require, exports, module) {
  //prettier-ignore
  var _         = require('underscore');
  BaseModel = require('fukit').BaseModel;

  var WorkflowBucketModel = BaseModel.extend({
    radioRequests: {
      'models WorkflowBucketModel': '@constructor',
    },

    urlRootTemplate: '/api/v1/compliance/disclosure/:documentId/bucket',
  });

  module.exports = WorkflowBucketModel;
});

